import React from "react";

const SvgProgressIcon = ({ progress }) => {
  const size = 50; // Tamanho total do SVG
  const radius = 20; // Raio do círculo
  const center = size / 2; // Centro do círculo

  // Converter o progresso para ângulo (0 a 360 graus)
  const angle = (progress / 100) * 360;
  const radians = (angle * Math.PI) / 180;

  // Cálculo das coordenadas para o ponto final da fatia da pizza
  const x = center + radius * Math.cos(radians - Math.PI / 2);
  const y = center + radius * Math.sin(radians - Math.PI / 2);

  // Determinar se o arco é maior que 180 graus para o `large-arc-flag`
  const largeArcFlag = progress > 50 ? 1 : 0;

  // Criar o caminho SVG para a fatia da pizza
  const pathData = `
    M ${center} ${center}
    L ${center} ${center - radius}
    A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x} ${y}
    Z
  `;

  return (
    <svg  width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {/* Círculo de fundo (cor cinza) */}
      <circle cx={center} cy={center} r={radius} fill="white" stroke="black" />

      {/* Fatia de pizza preenchida */}
      <path d={pathData} fill="black" stroke="black" strokeWidth="1" />
    </svg>
  );
};

export default SvgProgressIcon;


